<template>
    <ul class="slm-event-list__results-list">
        <Event v-for="event in events" :key="event.url" :event="event"/>
    </ul>
</template>

<script>
import Event from './Event.vue'
export default {
    name: 'event-list',
    props: ['events'],
    computed: {
    },
    components: {
        Event
    }
}
</script>
